import React from "react";

interface RenderPageProps {
  title: string;
  children: React.ReactNode;
  path?: string; // Add optional path prop
}

export default function RenderPage({ title, children, path }: RenderPageProps) {

  const pathCheck = (str: string,LineNumber:Number) => {
    if(LineNumber === 1) {
      if(str === "/bambinos-uc-test") {
        return "Experience the two AI agents for funnelling and optimising the Live Demos and";
      }else if (str === "/bambinos-uc-test3" || str === "/bambinos-uc-test4") {
        return "Experience the two AI agents for onboarding and pulse feedback calls.";
      }else {
        return "Experience our AI agents for enterprise use cases.";
      }
    } else if (LineNumber === 2) {
      if(str === "/bambinos-uc-test") {
        return "fallback recovery.";
      }else if (str === "/bambinos-uc-test3" || str === "/bambinos-uc-test4") {
        return "";
      }
      else {
        return "Feel free to try them out yourself.";
      }
    }else if(LineNumber === 3) {
      if(str === "/bambinos-uc-test") {
        return "Try them out yourself!";
      }else {
        return "";
      }
    }
  }
  return (
    <>
      <div className="titlehead">
        <div className="conversation-button">
          <div className="convicon">
            <img src="/convlogo.png" alt="Logo" />
          </div>
          <div className="text">Human-like conversations</div>
        </div>
        <div className="titlecontainer">
          <h1 className="title">{title}</h1>
          <p className="subtitle">
            {pathCheck(path || "", 1)}
          </p>
          <p className="subtitle">
            {pathCheck(path || "", 2)}
          </p>
        <p className="subtitle"> {pathCheck(path || "", 3)}</p>
        </div>
      </div>
      <div className="agentscontainer">
        <div className="agent-category">{children}</div>
      </div>
    </>
  );
}
